import AppIcon from "../../components/AppIcon";
import ClockApp from "./clock.jsx";
import RClock from "react-clock";
import { useState, useEffect, useRef } from "react";

const Clock = ({ systemData, updateSystemData, scale }) => {
  const [isOpen, setOpen] = useState(false);
  const [time, setTime] = useState(new Date());
  const [startDate, setStartDate] = useState(null);
  const [timerVal, setTimerVal] = useState(0);
  const timer = useRef();
  const clockObj = systemData
    ? systemData.clock
      ? systemData.clock
      : { index: 1 }
    : { index: 0 };
  const clockIndex = clockObj.index;
  const setClockIndex = (index) => {
    updateSystemData({
      clock: {
        index,
      },
    });
  };
  const refresh = () => {
    const minuteHands = document.getElementsByClassName(
      "react-clock__minute-hand__body"
    );
    const hourHands = document.getElementsByClassName(
      "react-clock__hour-hand__body"
    );
    const secHands = document.getElementsByClassName(
      "react-clock__second-hand__body"
    );
    const clockFaces = document.getElementsByClassName("react-clock__face");
    for (let i = 0; i < minuteHands.length; i++) {
      minuteHands[i].style.background = clockStyles[clockIndex].minuteHandColor;
    }
    for (let i = 0; i < hourHands.length; i++) {
      hourHands[i].style.background = clockStyles[clockIndex].hourHandColor;
    }
    for (let i = 0; i < secHands.length; i++) {
      secHands[i].style.background = clockStyles[clockIndex].secondHandColor;
    }
    for (let i = 0; i < clockFaces.length; i++) {
      clockFaces[i].style.background = clockStyles[clockIndex].clockFaceColor;
      clockFaces[i].style.color = clockStyles[clockIndex].textColor;
      clockFaces[i].style.border = "none";
    }
  };
  useEffect(refresh, [clockIndex]);
  const clocks = [
    <RClock
      value={time}
      hourHandOppositeLength={1}
      minuteHandOppositeLength={1}
      secondHandOppositeLength={1}
      renderNumbers={false}
      renderMinuteMarks={false}
      renderHourMarks={false}
    />,
    <RClock
      value={time}
      renderNumbers={true}
      hourHandOppositeLength={10}
      minuteHandOppositeLength={10}
      renderMinuteMarks={false}
      hourMarksLength={3}
      hourMarksWidth={2}
    />,
    <RClock
      value={time}
      hourHandLength={30}
      minuteHandLength={60}
      secondHandLength={80}
      hourHandOppositeLength={1}
      minuteHandOppositeLength={1}
      secondHandOppositeLength={1}
      renderNumbers={true}
      renderMinuteMarks={false}
      renderHourMarks={true}
      hourMarksLength={0}
    />,
    <RClock
      value={time}
      renderNumbers={false}
      renderMinuteMarks={true}
      renderHourMarks={true}
      hourMarksWidth={3}
      minuteMarksWidth={2}
    />,
    <RClock
      value={time}
      renderNumbers={true}
      renderMinuteMarks={true}
      renderHourMarks={true}
      hourMarksLength={0}
      minuteMarksLength={0}
    />,
  ];
  const clockStyles = [
    {
      minuteHandColor: "black",
      hourHandColor: "black",
      clockFaceColor: "white",
      secondHandColor: "red",
      textColor: "white",
    },
    {
      minuteHandColor: "white",
      hourHandColor: "white",
      clockFaceColor: "red",
      secondHandColor: "yellow",
      textColor: "white",
    },

    {
      minuteHandColor: "red",
      hourHandColor: "red",
      clockFaceColor: "black",
      secondHandColor: "red",
      textColor: "red",
    },
    {
      minuteHandColor: "black",
      hourHandColor: "black",
      clockFaceColor: "linear-gradient(to right, #fc5c7d, #6a82fb)",
      secondHandColor: "white",
      textColor: "black",
    },
    {
      minuteHandColor: "black",
      hourHandColor: "black",
      clockFaceColor: "linear-gradient(to right, #40e0d0, #ff8c00, #ff0080)",
      secondHandColor: "white",
      textColor: "black",
    },
  ];

  useEffect(() => {
    const alarmObj = systemData ? systemData.alarm : { alarmList: [] };
    const alarmList = alarmObj ? alarmObj.alarmList : [];
    const interval = setInterval(() => {
      const now = new Date();
      for (let alarm of alarmList) {
        const alarmTime = new Date(alarm.time);
        if (
          !alarm.disabled &&
          alarmTime.getHours() === now.getHours() &&
          alarmTime.getMinutes() === now.getMinutes()
        ) {
          window.alert("Alarm");
          return;
        }
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [systemData]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      {isOpen && (
        <ClockApp
          time={time}
          setOpen={setOpen}
          startDate={startDate}
          setStartDate={setStartDate}
          timerVal={timerVal}
          setTimerVal={setTimerVal}
          timer={timer}
          systemData={systemData}
          updateSystemData={updateSystemData}
          clockIndex={clockIndex}
          setClockIndex={setClockIndex}
          clocks={clocks}
          refresh={refresh}
        />
      )}
      <AppIcon
        key={"clock"}
        scale={scale}
        icon={
          <RClock
            value={time}
            size={50}
            hourHandWidth={2}
            minuteHandWidth={1}
            secondHandWidth={0.7}
            secondHandLength={80}
            renderNumbers={false}
            renderSecondHand={true}
            renderMinuteMarks={false}
            renderHourMarks={false}
          />
        }
        name={"Clock"}
        width={100}
        height={110}
        onClick={() => setOpen(!isOpen)}
        nameOnChange={false}
        nameChangable={false}
      />
    </div>
  );
};

export default Clock;
